import { render, staticRenderFns } from "./TabsB.vue?vue&type=template&id=2598d1b0&scoped=true&lang=pug&"
import script from "./TabsB.vue?vue&type=script&lang=js&"
export * from "./TabsB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598d1b0",
  null
  
)

export default component.exports